function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.999 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 29.999,
    height: 29.999,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h29.999v19.999H0V5Z",
    style: {
      fill: "#377e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9h29.999v12H0v-12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11h29.999v8H0v-8Z",
    style: {
      fill: "#b40a2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.453,15.854l2.351-1.708h-2.906l-.898-2.764s-.474,1.459-.898,2.764h-2.906l2.351,1.708c-.424,1.305-.898,2.764-.898,2.764l2.351-1.708,2.351,1.708-.898-2.764Z",
    style: {
      fill: "#ecc81d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/SR.091c6862c4dd87c4ba0fe8e48995eac1.svg";
export { ForwardRef as ReactComponent };